/* eslint-disable camelcase */
import { Link } from 'react-router-dom';
import I18n from '../../../config/i18n';
import { Grid, Row, Col } from '../../../utils/grid/Grid';

import './booking-confirmation.css';

interface BookingConfirmationProps {
  mail_to: string;
  renter?: {
    mail: string;
  };
}

export default function BookingConfirmation({
  mail_to,
  renter,
}: BookingConfirmationProps): JSX.Element | null {
  if (!mail_to) {
    return null;
  }
  return (
    <Grid className="booking-confirmation-wrapper">
      <Row>
        <Col xs={12}>
          <div className="booking-confirmation">
            <h2 className="booking-confirmation-title">{I18n.t('booking.payment_accepted')}</h2>
            <p>
              {I18n.t('booking.confirmation_mail')}:<br />
              <span className="booking-confirmation-email">{renter?.mail}</span>
            </p>
            <p>
              {I18n.t('booking.confirmation_wrong_mail')}:<br />
              <a className="booking-confirmation-email" href={`mailto:${mail_to}`}>
                {mail_to}
              </a>
            </p>
            <p>{I18n.t('booking.confirmation_spam_notice')}</p>
            <Link to={`/${I18n.locale}`} reloadDocument>
              {I18n.t('previews.back_to_homepage')}
            </Link>
          </div>
        </Col>
      </Row>
    </Grid>
  );
}

const defaultProps: Pick<BookingConfirmationProps, 'renter'> = {
  renter: undefined,
};

BookingConfirmation.defaultProps = defaultProps;
